import * as z from "zod";

export const ContractDetailsBaseSchema = z.object({
  tradingPartner: z
    .number({
      required_error: "tradingpartnerRequired",
      invalid_type_error: "tradingpartnerRequired",
    })
    .nullable()
    .refine((val) => val !== null && val > 0, "tradingpartnerRequired"),
});

const ContractDetailsNewProductSchema = z.object({
  selectFromExisting: z.boolean(),
});

const ContractDetailsExistingProductSchema = z.object({
  selectFromExisting: z.boolean(),
  companySpecificProductId: z.number().min(1, "validation:productRequired"),
});

const ContractDetailsProductSchema = z.discriminatedUnion("selectFromExisting", [
  ContractDetailsExistingProductSchema.extend({
    selectFromExisting: z.literal(true),
  }),
  ContractDetailsNewProductSchema.extend({
    selectFromExisting: z.literal(false),
  }),
]);

export const ContractDetailsSchema = ContractDetailsBaseSchema.and(ContractDetailsProductSchema);

export type ContractDetailsInput = z.infer<typeof ContractDetailsSchema>;
